module.exports = "<li>\r\n    <label>\r\n\r\n        <input type=\"checkbox\" data-jurisdiction-id=\"{{Model.Id}}\" >\r\n        <span>{{Model.Name}}</span>\r\n    </label>\r\n    </li>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/jurisdiction-filter.html
// module id = 416
// module chunks = 1